<template>
  <div class="c-elements" ref="elements" @scroll="onElementsScroll">
    <div v-if="prevShow" class="arrow arrow-left">
      <div class="arrow-btn" @click="prevElement"><i class="el-icon-arrow-left"></i></div>
      <!-- <el-button
        icon="el-icon-arrow-left"
        size="mini"
        circle
        @click="prevElement"
      ></el-button> -->
    </div>
    <div v-if="nextShow" class="arrow arrow-right">
      <div class="arrow-btn" @click="nextElement"><i class="el-icon-arrow-right"></i></div>
      <!-- <el-button
        icon="el-icon-arrow-right"
        size="mini"
        circle
        @click="nextElement"
      ></el-button> -->
    </div>
    <template v-for="(item, idx) in list">
      <div
        v-if="!item.hidden"
        :key="idx"
        class="c-element"
        @click="$emit('click-item', item)"
      >
        <img class="c-ele-img" :src="item.img" :data-src="item.img" :data-index="idx"/>
        <div class="c-ele-text" v-html="item.title"></div>
        <div class="c-ele-sub">{{ item.subtitle }}</div>
        <i v-if="item.src" class="el-icon-right c-ele-icon"></i>
        <span v-else class="c-ele-next">即将上线</span>
        <!-- <img
          src="@/assets/images/loading.png"
          v-if="item.cover"
          :data-src="item.cover"
          :data-index="idx"
          class="cover"
        /> -->
        <!-- <div v-else class="no-cover">
          <div>
            <div>{{ item.title }}</div>
            <div>{{ item.createTime }}</div>
          </div>
        </div> -->
        <!-- <div class="item-title">{{ item.title }}</div> -->
      </div>
    </template>
  </div>
</template>

<script>
let observer = null
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      prevShow: false,
      nextShow: false
    }
  },
  watch: {
    // list: {
    //   handler (val) {
    //     this.nextShow = this.clientWidth >= 1670
    //   },
    //   immediate: true
    // },
    clientWidth: {
      immediate: true,
      handler (val) {
        this.nextShow = val < ( this.width+16 ) * this.list.length
      }
    }
  },
  computed: {
    clientWidth () {
      return this.$store.getters['app/clientWidth']
    },
    width () {
      return 220
      // return this.clientWidth >= 1462 ? 320 : this.clientWidth > 1266 ? 280 : 240
    }
  },
  methods: {
    imgViewListener () {
      // console.log('打开', Array.from(document.querySelectorAll('.c-element img')).length, observer)
      observer = new IntersectionObserver(function (changes) {
        if (changes[0].intersectionRatio <= 0) return
        changes.forEach(function (change) {
          const container = change.target
          container.src = container.dataset.src
          observer.unobserve(container)
        })
      })
      Array.from(document.querySelectorAll('.c-element img')).forEach(item => {
        observer.observe(item)
      })
    },
    prevElement () {
      let left = this.$refs.elements.scrollLeft
      const allWidth = this.width + 16
      left =
        left -
        allWidth * 3 +
        (allWidth - (left - Math.floor(left / allWidth) * allWidth))
      this.$refs.elements.scroll({
        left,
        behavior: 'smooth'
      })
    },
    nextElement () {
      let left = this.$refs.elements.scrollLeft
      const allWidth = this.width + 16
      left = Math.floor(left / allWidth) * allWidth + allWidth * 3
      this.$refs.elements.scroll({
        left,
        behavior: 'smooth'
      })
    },
    onElementsScroll (e) {
      if (!this.setTime) {
        const allWidth = this.width + 16
        this.setTime = window.requestAnimationFrame(() => {
          if (this.$refs.elements.scrollLeft > 0) {
            this.prevShow = true
          } else {
            this.prevShow = false
          }
          // console.log(this.$refs.elements.scrollLeft, allWidth * this.list.length, this.$refs.elements.offsetWidth)
          if (
            this.$refs.elements.scrollLeft <
            allWidth * this.list.length - 0 - this.$refs.elements.offsetWidth
          ) {
            this.nextShow = true
          } else {
            this.nextShow = false
          }
          this.setTime = null
        })
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.imgViewListener()
      }, 200)
    })
  },
  beforeDestroy () {
    observer && observer.disconnect()
    observer = null
  }
}
</script>

<style lang="scss" scoped>
$base_width: 220px;
$base_height: 126px;
// @media (min-width: 1462px) {
//   .c-elements {
//     height: $base_height * 4;
//     .c-element {
//       width: $base_width * 4;
//     }
//   }
//   .arrow {
//     height: $base_height * 4;
//   }
// }
// @media (max-width: 1461px) {
//   .c-elements {
//     height: 210px;
//     .c-element {
//       width: 280px;
//     }
//   }
//   .arrow {
//     height: 210px;
//   }
// }
// @media (max-width: 1266px) {
//   .c-elements {
//     height: $base_height * 3;
//     .c-element {
//       width: $base_width * 3;
//     }
//   }
//   .arrow {
//     height: $base_height * 3;
//   }
// }
.c-elements {
  display: flex;
  overflow: hidden;
  margin-top: 16px;
  padding: 0 16px;
  height: 138px;
  .c-element {
    width: $base_width;
    height: $base_height;
    background-color: #fff;
    position: relative;
    border-radius: 8px;
    margin-top: 0;
    padding: 16px 0 16px 16px;
    flex-shrink: 0;
    overflow: hidden;
    color: #323337;
    font-weight: bold;
    border: 1px solid #ececec;
    display: border-box;
    cursor: pointer;
    .c-ele-img {
      display: inline-block;
      width: 32px;
      height: 32px;
      border-radius: 4px;
    }
    .c-ele-text {
      font-weight: 500;
      font-size: 14px;
      margin: 12px 0 4px;
    }
    .c-ele-sub {
      font-size: 12px;
      font-weight: 400;
      color: #cccccc;
    }
    .c-ele-next {
      position: absolute;
      font-size: 14px;
      font-weight: 400;
      right: 24px;
      top: 20px;
      color: #CCCCCC;
    }
    .c-ele-icon {
      position: absolute;
      font-size: 20px;
      right: 24px;
      top: 20px;
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    &:hover {
      box-shadow: 0px 2px 6px rgba(23, 23, 26, 0.1);
      .c-ele-icon {
        opacity: 1;
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
    .item-title {
      position: absolute;
      left: 16px;
      bottom: 16px;
      z-index: 2;
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    .no-cover {
      position: relative;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(90deg, #9f9f9f 1%, #7f7f7f 100%);
      text-align: center;
      cursor: pointer;
      & > div {
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
        color: #ffffff;
        div:first-child {
          padding: 0 32px;
          font-weight: bold;
          font-size: 18px;
        }
        div:last-child {
          font-size: 12px;
        }
      }
    }
    &:not(:last-child) {
      margin-right: 16px;
    }
    // &::after {
    //   content: "";
    //   position: absolute;
    //   left: 0;
    //   bottom: 0;
    //   width: 100%;
    //   height: 80px;
    //   background-image: linear-gradient(
    //     180deg,
    //     rgba(0, 0, 0, 0) 0%,
    //     rgba(0, 0, 0, 0.4) 100%
    //   );
    //   opacity: 0;
    //   transition: opacity 0.3s ease;
    // }
    // &:hover {
    //   .item-title,
    //   &:after {
    //     opacity: 1;
    //   }
    // }
  }

  // 左右箭头
  .arrow {
    height: $base_height;
    position: absolute;
    top: 0;
    z-index: 1;
    width: 28px;
    .arrow-btn {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 50%;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: #FFFFFF;
      border: 1px solid #E0E0E0;
      transform: translateY(-50%);
      box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.08);
      cursor: pointer;
      &>i {
        color: #323337;
        font-weight: 600;
      }
    }
    // & > button {
    //   position: absolute;
    //   top: 50%;
    //   transform: translateY(-50%);
    //   border: 1px solid #E0E0E0;
    //   box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.08);
    //   [class^="el-icon-"], [class*=" el-icon-"] {
    //     font-weight: 600;
    //     color: #323337;
    //   }
    // }
    &-left {
      left: 16px;
    }
    &-right {
      right: 16px;
    }
  }
}
</style>
